import template from './index.html';
import style from './style.scss';
import '../../../../vendor/style/meanmenu.scss';
import $ from '../../../../vendor/js/jquery';

export default ['headerMenu', ['$http', '$rootScope', '$filter', '$state', '$interval', '$timeout', function ($http, $rootScope, $filter, $state, $interval, $timeout) {
    'ngInject';

    return {
        restrict: 'AEC',
        template: template,
        scope: {},
        link: function (scope) {
            scope.style = style;
            scope.$on('onLoadGeneral', () => {
                scope.showMenu = true;
                $('nav#dropdown').meanmenu();
                
                $timeout(() => {
                    $('#busca').typeahead({
                        minLength: 3,
                        autoSelect: false,
                        source: function (query, process) {
                            $http.get($rootScope.backURL + 'application/site/search?term=' + query + '&limit=6').then(function (rs) {
                                process(rs.data.data.result.map(p => ({
                                    name: p.nome + '!@' + (p.imagens.length > 0 ? p.imagens[0].imagem : ''),
                                    id: p.id,
                                    urlcategoria: p.categorias[0].id + '-' + p.categorias[0].url.url,
                                    urlproduto: p.id + '-' + p.url.url,
                                    product: p
                                })));
                            }, function () {});
                        },
                        highlighter: function (item) {
                            var items = item.split('!@');
    
                            return '<div class="row">' + (items[1] ? '<div class="col-xs-4"><img src="' + $rootScope.backURL + 'lib.data/produtos/' + $filter('resizeImage')(items[1], 70, 70) + '" class="img-circle" /></div>' : '') + '<div class="' + (items[1] ? 'col-xs-8' : '') + '"><p style="white-space: normal !important;">' + items[0] + '</p></div></div>';
                        },
                        afterSelect: function (item) {
                            $rootScope.setProduto(item.product);
                            $state.go('app.detail', {
                                id: item.product.id,
                                url: item.product.url.url
                            });
                            $('#busca').val('');
                            $interval(function () {
                                $('html, body').animate({
                                    scrollTop: ($('.header-bottom-area').offset().top)
                                }, 500);
                            }, 1000, 1);        
                        }
                    });
                }, 100);

            });
        }
    };
}]];



// WEBPACK FOOTER //
// ./src/app/directives/header/menu/index.js